import store from '../store'
import http from '../utils/http'
import jQuery, { data } from 'jquery'

store.commit('update', {
	isWxEnv: /wxwork/i.test(navigator.userAgent), // 结果为true或者false
	isMobile: /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(navigator.userAgent) // true:mobile端, false：PC端
})

function getQueryString(name) {
	var searchStr = window.location.href.split('?')[1];
	var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
	var r = searchStr ? searchStr.match(reg) : null;
	return r != null ? decodeURIComponent(r[2]) : '';
}
/**
 * 存储到本地
 * @param {授权参数} params
 */
const afterAuth = (params) => {
	const query = getQueryString('token')
	const tenantId = getQueryString('tenantId')
	if (params && params.token || query) {
		// 拿到正常授权之后调用后端登陆接口
		jQuery.ajax({
			type: 'POST',
			url: '/saas-community/live/user/login',
			contentType: "application/json;charset=utf-8",
			beforeSend: (xhr) => {
				xhr.withCredentials = true;
			},
			data: JSON.stringify({ token: params.token || query, tenantId: params.tenantId || tenantId }),
			dataType: 'json',
			success: (res) => {
				if (res.code === '200') {
					store.commit('update', {
						isLogin: true,
						token: res.data.authorization,
						tenantId: params.tenantId || tenantId,
						appId: res.data.appId,
						appType: res.data.appType,
						userId: res.data.userId,
						shareTitle: res.data.shareCopy || '邀请你加入【及象兴趣社区】，参与互动，分享兴趣爱好……',
						shareImageUrl: res.data.shareImg || 'https://ggpt.sunlands.com/saas-community/share.png'
					})
				} else {
					store.commit('update', {
						isLogin: false,
						token: '',
						tenantId: '',
						error: res.msg || '系统错误，请稍后重试～',
					})
				}
			},
			error: () => {
				store.commit('update', {
					isLogin: false,
					token: '',
					tenantId: '',
					error: '系统错误，请稍后重试～',
				})
			},
			async: false
		})
	} else {
		store.commit('update', {
			isLogin: false,
			token: '',
			error: '缺少token',
		})
	}
}

// 微信公众号授权
const getWXConfig = (params) => {
	let newurl = ''
	if (!window.initUrl) {
		window.initUrl = location.href.split('#')[0];
	}
	if (/(Android)/i.test(navigator.userAgent)) {
		newurl = location.href.split('#')[0]
	} else {
		newurl = window.initUrl
	}
	console.log(70, newurl, window.initUrl, location.href.split('#')[0])
	http.post("/saas-community/live/home/oaInfo", {
		url: newurl,
		appId: params.appId,
		appType: params.appType,
	}).then((res) => {
		if (!res.data) {
			return;
		}
		let data = res.data;
		store.commit('update', {
			oaAppId: data.oaAppId
		})
		console.log(83, "oaInfo", res.data)
		let newToken = getQueryString('token') == 'b3pZWHM2NVFTYlZVYkhHcDFtS2JkeFAyZDhvWTozMDE=' || getQueryString('token') == 'b0ZvMEk0MmFablljT1RIMU5RV0VYX091czM5SToz' || getQueryString('token') == 'b0ZvMEk0NFAybE5iVEFpU2FzMndLdFR2WkRDRTox'
		console.log(91, newToken)
		wx.config({
			debug: newToken ? true : false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
			appId: data.oaAppId, // 必填，企业微信的corpID
			timestamp: data.timestamp, // 必填，生成签名的时间戳
			nonceStr: data.nonceStr, // 必填，生成签名的随机串
			signature: data.signature, // 必填，签名，见 附录-JS-SDK使用权限签名算法
			jsApiList: ['startRecord', 'stopRecord', 'onVoiceRecordEnd', 'playVoice', 'pauseVoice', 'stopVoice', 'onVoicePlayEnd', 'uploadVoice', 'downloadVoice'] // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
		})
	})
}
export default {
	afterAuth,
	getWXConfig
}



// WEBPACK FOOTER //
// ./src/jssdk/index.js